const { Type } = require('@sinclair/typebox');
const Blockly = require('blockly');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');

const TOOLTIP = "Filter a given control's contents based on the current route";

function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);

    line1OfInputs.appendField('  Property Name:').appendField(new Blockly.FieldTextInput('routePath'), 'propertyName');
}

function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['propertyName']);
    return code;
}

/** Builds the filter metadata fragment for the ByCurrentRoute block. */
function asDataDictionary(hNode, context) {
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};
    const { id, propertyName } = hNode;
    
    // whatever the relation context we are in, it is expected to have `propertyName` as (string) property
    const routeSchema = Type.String({
        'x-id': id,
        'x-dataType': 'string',
        'x-propertyName': propertyName
    });
    
    const partialTypeDefinition = {
        [propertyName]: routeSchema
    };
    
    //And the given foreignKey exists on the parent object.
    return [subDataDictionary, partialTypeDefinition];
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode, asDataDictionary };
